@use '~/theme/theme' as *;

.container {
  padding: spacing(5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: spacing(5);
}

.error {
  align-self: center;
}
